<template>
    <div>
        <app-layout>
            <template #header>
                <AppHead title="Payment Confirmation" />
                <h2 class="title">
                    Payment

                    <span v-if="for_user && for_user.first_name">By {{ for_user.first_name }} {{ for_user.last_name
                    }}</span>
                    <span v-else-if="isTu() && payment.id">#{{ payment.id }}</span>
                    <span v-else>By guest user</span>
                </h2>
                <flash-messages />
            </template>

            <section class="py-2">
                <div class="row">
                    <div class="col-12 col-lg-6">
                        <card>
                            <ul class="list-unstyled">
                                <li>Amount: <span class="font-weight-bold">{{ formatDollars(payment.total) }}</span></li>
                                <li>Date Paid: <span>{{ moment(payment.transaction_date).format('M/D/YY h:mm A') }}</span>
                                </li>
                            </ul>
                            <jet-button @click="openPrintPaymentReceipt(payment.id)" icon="fas fa-file-invoice-dollar">Print
                                Receipt</jet-button>
                        </card>

                        <card title="Payment Method" class="mt-3 mb-3 mb-lg-0">
                            <div v-if="payment.type == 'Cash' || payment.type == 'Check'">
                                <p class="mb-1 font-weight-bold">{{ payment.type }} {{ payment.check_number ? '#' +
                                    payment.check_number : '' }} Accepted</p>
                                <p class="mb-0" v-if="payment.cash_session_item">Cash Tendered: <span
                                        class="text-success">{{ formatDollars(payment.cash_session_item.credit_amount)
                                        }}</span></p>
                                <p class="mb-0" v-if="payment.cash_session_item">Change: <span class="text-success">{{
                                    formatDollars(payment.cash_session_item.debit_amount) }}</span></p>
                            </div>
                            <div v-else-if="payment.payment_method?.cc_image_url" class="text-secondary text-size-small">
                                <img :src="payment.payment_method.cc_image_url" :alt="payment.payment_method.brand"
                                    width="32" /> ending in {{ payment.payment_method.last4 }}
                            </div>
                            <div v-else-if="payment.type == 'ACH'">
                                <p class="mb-0">{{ payment.payment_method.bank_name }} <span
                                        class="text-secondary text-size-small">ending in {{ payment.payment_method.last4
                                        }}</span></p>
                            </div>
                        </card>
                    </div>
                    <div class="col-12 col-lg-6" id="payment_progress">
                        <PaymentProgress :for_user="for_user" :charges="charges" />
                    </div>
                </div>
            </section>
            <teleport to="body">
                <PrintModal :printUrl="printUrl" @print="print" />
            </teleport>
        </app-layout>
    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import PrintModal from '@/Components/Modals/PrintModal'
import moment from 'moment'
import PaymentProgress from '@/Components/Payment/PaymentProgress'

export default {
    components: {
        AppLayout,
        PaymentProgress,
        PrintModal
    },
    props: {
        for_user: Object,
        payment: Object,
        charges: Array,
    },
    data() {
        return {
            selectedReceiptPaymentId: null,
            printUrl: '',
        }
    },
    created() {
        this.moment = moment;
    },
    methods: {
        openPrintPaymentReceipt(paymentId) {
            this.selectedReceiptPaymentId = paymentId
            this.printUrl = this.route('tu.payment.receipt', this.selectedReceiptPaymentId);
            $('#PrintModal').modal('show');
        },
        print() {
            this.printUrl = this.route('tu.payment.receipt', { payment: this.selectedReceiptPaymentId, print: 1 });
        },
        cancelPayment() {
            this.$confirm.require({
                message: 'Are you sure?',
                header: 'Cancel this payment, refund funds?',
                icon: null,
                acceptLabel: 'Continue',
                rejectLabel: 'Close',
                accept: () => {
                    this.$inertia.visit(this.route('mtd.orders.cancelaccountbalancepayment', this.payment))
                },
                reject: () => {
                    //callback to execute when user rejects the action
                }
            });
        },
    },
}
</script>
